import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';
import { LanguageProvider } from './context/LanguageContext';

// Polyfills for Node.js built-ins
import { Buffer } from 'buffer';
window.Buffer = Buffer;

// Disable SES lockdown if it exists (from snarkjs/circomlibjs)
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.lockdown = () => {};
  // @ts-ignore
  if (window.harden) {
    // @ts-ignore
    window.harden = (x: any) => x;
  }
}

// Temporarily disabled A11yProvider due to a React hooks conflict
// import { A11yProvider } from './components/A11yProvider';

const rootElement = document.getElementById('root');
if (rootElement) {
  createRoot(rootElement).render(
    <StrictMode>
      <LanguageProvider>
        <App />
      </LanguageProvider>
    </StrictMode>
  );
}